import React from "react";
import { useField } from "formik";
import { Input, Alert } from "@material-tailwind/react";

export default function FormikInput({ ...props }) {
    const [field, meta] = useField(props);

    return (
        <>
            <Input
                className="bg-none"
                {...field}
                {...props}
                labelProps={{
                    // The MT floating label is absolutely positioned and
                    // never wraps; cap it at the field edge so an over-long
                    // label truncates instead of escaping the input.
                    className: "!text-gobbygray font-body max-w-full truncate",
                }}
                value={meta.value || ""}
                error={meta.touched && meta.error ? true : undefined}
            />
            {!!(meta.touched && meta.error) && (
                <Alert
                    color="red"
                    className="mt-1 rounded-lg py-2 px-1 text-sm"
                >
                    {meta.error}
                </Alert>
            )}
        </>
    );
}
